(function () {
  if (window.__invoiceRequestWidgetAppV7Loaded) return;
  window.__invoiceRequestWidgetAppV7Loaded = true;

  const LOCALE = (document.documentElement.lang || "").toLowerCase().startsWith("it") ? "it" : "en";

  const strings = {
    it: {
      saving: "Sto registrando la richiesta fattura...",
      saved: "Richiesta fattura registrata. Le richieste incomplete non saranno prese in carico.",
      companySaved: "Dati fattura azienda registrati.",
      reverseChargeGranted: "VAT valido. Reverse charge confermato: usa la stessa email al checkout per mantenere l’esenzione IVA.",
      vatExemptApplied: "VAT valido. Profilo cliente preparato per esenzione IVA: usa la stessa email al checkout.",
      manualReviewSaved: "Richiesta fattura registrata. La verifica VAT richiede controllo manuale: completa il checkout e, se ti serve reverse charge, contatta l’assistenza.",
      viesBusySaved: "VIES momentaneamente occupato. Richiesta fattura registrata: completa il checkout e, se ti serve reverse charge, contatta l’assistenza.",
      taxExemptWarning: "VAT valido, ma non siamo riusciti a preparare automaticamente l’esenzione IVA. Completa il checkout e contatta l’assistenza per il reverse charge.",
      emailRequired: "Inserisci un’email valida: serve per preparare il profilo cliente e mantenere il reverse charge al checkout.",
      companyLoginRequired: "Per richiedere una fattura aziendale devi effettuare l’accesso.",
      companyContextRefresh: "Azienda e permessi preparati. Aggiorno il tuo accesso aziendale…",
      vatRequired: "Inserisci la partita IVA / VAT number.",
      error: "Non sono riuscito a registrare la richiesta. Riprova.",
      resetError: "Non sono riuscito ad aggiornare la richiesta fattura. Riprova.",
    },
    en: {
      saving: "Saving invoice request...",
      saved: "Invoice request saved. Continue to checkout and, where applicable, enter your fiscal code and certified email/PEC in the dedicated fields. Incomplete requests will not be processed.",
      companySaved: "Company invoice details saved.",
      reverseChargeGranted: "VAT valid. Reverse charge confirmed: use the same email at checkout to keep VAT exemption.",
      vatExemptApplied: "VAT valid. Customer profile prepared for VAT exemption: use the same email at checkout.",
      manualReviewSaved: "Invoice request saved. VAT verification requires manual review: complete checkout and contact support if you need reverse charge.",
      viesBusySaved: "VIES is temporarily busy. Your invoice request was saved: complete checkout and contact support if you need reverse charge.",
      taxExemptWarning: "VAT valid, but we could not automatically prepare VAT exemption. Complete checkout and contact support for reverse charge.",
      emailRequired: "Enter a valid email: it is required to prepare the customer profile and keep reverse charge at checkout.",
      companyLoginRequired: "You must sign in to request a company invoice.",
      companyContextRefresh: "Company and purchasing permissions are ready. Refreshing your business access…",
      vatRequired: "Enter the VAT number.",
      error: "Could not save the invoice request. Please try again.",
      resetError: "Could not update the invoice request. Please try again.",
    },
  };

  const t = strings[LOCALE] || strings.en;
  let syncing = false;
  let syncTimer = null;
  let cartWriteQueue = Promise.resolve();

  function widgetFrom(element) {
    return element && element.closest ? element.closest("[data-invoice-request-widget]") : null;
  }

  function setMessage(widget, text, type) {
    const message = widget && widget.querySelector ? widget.querySelector("[data-invoice-message]") : null;
    if (!message) return;

    message.textContent = text || "";
    message.classList.remove("is-success", "is-error", "is-loading");

    if (type === "error") message.classList.add("is-error");
    if (type === "success") message.classList.add("is-success");
    if (type === "loading") message.classList.add("is-loading");
  }

  function setPanels(widget, value) {
    const privatePanel = widget.querySelector("[data-invoice-private]");
    const companyPanel = widget.querySelector("[data-invoice-company]");
    const companyLoginGate = widget.querySelector("[data-invoice-company-login-gate]");
    const companyNeedsLogin =
      value === "company" &&
      requiresCompanyLogin(widget) &&
      !isLoggedCustomer(widget);

    if (privatePanel) privatePanel.hidden = value !== "private";
    if (companyPanel) companyPanel.hidden = value !== "company" || companyNeedsLogin;
    if (companyLoginGate) companyLoginGate.hidden = !companyNeedsLogin;

    updateItalianFiscalFields(widget);
  }

  function setChecked(widget, value) {
    const input = widget.querySelector(`input[name="invoice_type"][value="${value}"]`);
    if (input) input.checked = true;
    setPanels(widget, value || "none");
  }

  function setBusy(widget, busy) {
    if (!widget) return;
    widget.toggleAttribute("data-invoice-busy", Boolean(busy));

    widget.querySelectorAll('input[name="invoice_type"], [data-invoice-validate]').forEach((element) => {
      element.disabled = Boolean(busy);
    });
  }

  function normalizeBool(value) {
    return value === true || value === "true" || value === "1" || value === 1;
  }

  function getCompanyCountry(widget) {
    return (widget.querySelector("[data-invoice-country]")?.value || "IT").toUpperCase();
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || "").trim());
  }

  function getVatPrefixForCountry(country) {
    const cleanCountry = String(country || "").trim().toUpperCase();
    if (cleanCountry === "AT") return "ATU";
    return cleanCountry || "IT";
  }

  function updateVatPrefix(widget) {
    if (!widget) return;

    const country = getCompanyCountry(widget);
    const prefix = widget.querySelector("[data-invoice-vat-prefix]");

    if (prefix) {
      prefix.textContent = getVatPrefixForCountry(country);
    }
  }

  function normalizeVatInputValue(country, vat) {
    const cleanCountry = String(country || "").trim().toUpperCase();
    let raw = String(vat || "")
      .trim()
      .replace(/[\s.\-_/]/g, "")
      .toUpperCase();

    if (!raw) return "";

    if (cleanCountry === "AT") {
      return raw
        .replace(/^ATU/, "")
        .replace(/^AT/, "")
        .replace(/^U/, "");
    }

    if (cleanCountry && raw.startsWith(cleanCountry)) {
      return raw.slice(2);
    }

    return raw.replace(/^[A-Z]{2}/, "");
  }

  function buildVatForSelectedCountry(country, vat) {
    const cleanCountry = String(country || "").trim().toUpperCase();
    const cleanVat = normalizeVatInputValue(cleanCountry, vat);

    if (!cleanVat) return "";

    if (cleanCountry === "AT") {
      return `ATU${cleanVat}`;
    }

    return `${cleanCountry}${cleanVat}`;
  }

  function requiresCompanyLogin(widget) {
    return widget?.dataset?.invoiceCompanyLoginRequired === "true";
  }

  function isLoggedCustomer(widget) {
    return widget?.dataset?.invoiceCustomerLoggedIn === "true";
  }

  function getLoggedCustomerEmail(widget) {
    return widget?.dataset?.invoiceCustomerEmail || "";
  }

  function updateItalianFiscalFields(widget) {
    if (!widget) return;

    const country = getCompanyCountry(widget);
    updateVatPrefix(widget);
    const isItaly = country === "IT";
    const isLogged = isLoggedCustomer(widget);

    widget.querySelectorAll("[data-invoice-it-field]").forEach((field) => {
      field.hidden = !isItaly;

      field.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = !isItaly;
        if (!isItaly) input.value = "";
      });
    });

    widget.querySelectorAll("[data-invoice-non-it-field]").forEach((field) => {
      field.hidden = isItaly;

      field.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = isItaly;
        if (isItaly) input.value = "";
      });
    });

    widget.querySelectorAll("[data-invoice-non-it-guest-field]").forEach((field) => {
      const shouldHide = isItaly || isLogged;
      field.hidden = shouldHide;

      field.querySelectorAll("input, select, textarea").forEach((input) => {
        input.disabled = shouldHide;
        if (shouldHide && isLogged) input.value = getLoggedCustomerEmail(widget);
        if (isItaly) input.value = "";
      });
    });
  }

  function getCompanySuccessMessage(proxyData) {
    if (proxyData?.message) return proxyData.message;
    if (proxyData?.viesTechnicalError || proxyData?.viesUnavailable) return t.viesBusySaved;
    if (proxyData?.taxExemptWarning || proxyData?.requiresLoginForTaxExemption) return t.taxExemptWarning;
    if (proxyData?.pendingManualReview || proxyData?.reviewRequired) return t.manualReviewSaved;
    if (proxyData?.taxExemptApplied || proxyData?.taxExemptCustomerPrepared) return t.vatExemptApplied;
    if (proxyData?.reverseCharge) return t.reverseChargeGranted;
    return t.companySaved;
  }

  function getCartAjaxUrl(path) {
    const root = window.Shopify?.routes?.root || "/";
    return `${root}${String(path || "").replace(/^\/+/, "")}`;
  }

  async function getCart() {
    const response = await fetch(getCartAjaxUrl("cart.js"), {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });

    if (!response.ok) throw new Error("Cart read failed");
    return response.json();
  }

  function normalizeCartAttributes(attributes) {
    return Object.fromEntries(
      Object.entries(attributes || {})
        .filter(([key]) => Boolean(key))
        .map(([key, value]) => [
          String(key),
          value === undefined || value === null ? "" : String(value),
        ]),
    );
  }

  function cartAttributesMatch(cart, expected) {
    const current = cart?.attributes || {};

    return Object.entries(expected).every(([key, value]) => {
      return String(current[key] ?? "") === String(value ?? "");
    });
  }

  async function readCartResponse(response) {
    const raw = await response.text();

    try {
      return raw ? JSON.parse(raw) : {};
    } catch (_error) {
      return { raw };
    }
  }

  async function postCartAttributesJson(attributes) {
    const response = await fetch(getCartAjaxUrl("cart/update.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ attributes }),
    });

    const data = await readCartResponse(response);

    if (!response.ok) {
      const detail =
        data?.description ||
        data?.message ||
        data?.raw ||
        `HTTP ${response.status}`;

      throw new Error(`Cart update failed: ${detail}`);
    }

    return data;
  }

  async function postCartAttributesForm(attributes) {
    const body = new URLSearchParams();

    Object.entries(attributes).forEach(([key, value]) => {
      body.append(`attributes[${key}]`, value);
    });

    const response = await fetch(getCartAjaxUrl("cart/update.js"), {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body,
    });

    const data = await readCartResponse(response);

    if (!response.ok) {
      const detail =
        data?.description ||
        data?.message ||
        data?.raw ||
        `HTTP ${response.status}`;

      throw new Error(`Cart update failed: ${detail}`);
    }

    return data;
  }

  async function saveCartAttributesOnce(attributes) {
    let cart;

    try {
      cart = await postCartAttributesJson(attributes);
    } catch (jsonError) {
      console.warn("[Invoice Request] JSON cart attribute update failed, retrying form encoded", {
        error: jsonError?.message || String(jsonError),
      });

      cart = await postCartAttributesForm(attributes);
    }

    if (cartAttributesMatch(cart, attributes)) {
      return cart;
    }

    const verifiedCart = await getCart();

    if (!cartAttributesMatch(verifiedCart, attributes)) {
      throw new Error("Cart update was overwritten by another cart request");
    }

    return verifiedCart;
  }

  async function saveCartAttributes(attributes) {
    const normalizedAttributes = normalizeCartAttributes(attributes);

    const write = async () => {
      let lastError;

      for (let attempt = 1; attempt <= 3; attempt += 1) {
        try {
          return await saveCartAttributesOnce(normalizedAttributes);
        } catch (error) {
          lastError = error;

          console.warn("[Invoice Request] Cart attribute write attempt failed", {
            attempt,
            error: error?.message || String(error),
          });

          if (attempt < 3) {
            await new Promise((resolve) => window.setTimeout(resolve, 180 * attempt));
          }
        }
      }

      console.error("[Invoice Request] Cart attribute update failed permanently", {
        attributes: normalizedAttributes,
        error: lastError?.message || String(lastError),
      });

      throw lastError || new Error("Cart update failed");
    };

    const result = cartWriteQueue.then(write, write);
    cartWriteQueue = result.catch(() => undefined);

    return result;
  }

  async function saveInvoiceRequest(payload) {
    const cart = await getCart();

    const response = await fetch("/apps/invoice-request/validate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({
        cartToken: cart.token || "",
        locale: LOCALE,
        ...payload,
      }),
    });

    let data = {};
    try {
      data = await response.json();
    } catch (_error) {
      data = {};
    }

    if (!response.ok || !data.ok) {
      throw new Error(data.error || "Invoice request failed");
    }

    return data;
  }

  async function clearInvoiceRequest() {
    await saveCartAttributes({
      invoice_requested: "",
      invoice_type: "",
      invoice_request_status: "",
      invoice_request_id: "",
      vat_number: "",
      invoice_country_code: "",
      pec: "",
      sdi: "",
      company_name: "",
      vies_checked: "",
      vies_valid: "",
      reverse_charge: "",
      tax_exempt_applied: "",
      tax_exempt_customer_prepared: "",
      vies_technical_error: "",
      customer_email: "",
      must_use_same_email_at_checkout: "",
    });
  }

  async function handleTypeChange(input) {
    const widget = widgetFrom(input);
    if (!widget) return;

    const value = input.value;
    setPanels(widget, value);

    if (value === "none") {
      setBusy(widget, true);
      setMessage(widget, "", null);

      try {
        await clearInvoiceRequest();
        setPanels(widget, "none");
      } catch (_error) {
        setMessage(widget, t.resetError, "error");
      } finally {
        setBusy(widget, false);
      }

      return;
    }

    if (value === "private") {
      setBusy(widget, true);
      setPanels(widget, "private");
      setMessage(widget, t.saving, "loading");

      try {
        const proxyData = await saveInvoiceRequest({
          invoiceType: "private",
        });

        await saveCartAttributes({
          invoice_requested: "true",
          invoice_type: "private",
          invoice_request_status: "registered",
          invoice_request_id: proxyData.invoiceRequestId || "",
          vat_number: "",
          invoice_country_code: "",
          pec: "",
          sdi: "",
          company_name: "",
          vies_checked: "false",
          vies_valid: "",
          reverse_charge: "false",
          tax_exempt_applied: "false",
          vies_technical_error: "false",
        });

        setChecked(widget, "private");
        setMessage(widget, t.saved, "success");
      } catch (error) {
        setChecked(widget, "private");
        setMessage(widget, error.message || t.error, "error");
      } finally {
        setBusy(widget, false);
      }

      return;
    }

    if (value === "company") {
      setPanels(widget, "company");
      setMessage(widget, "", null);
    }
  }


  const COMPANY_PENDING_KEY = "invoice_company_pending_request_v1";

  function savePendingCompanyRequest(payload, proxyData) {
    try {
      window.sessionStorage.setItem(
        COMPANY_PENDING_KEY,
        JSON.stringify({
          payload,
          proxyData,
          createdAt: Date.now(),
        }),
      );
      return true;
    } catch (error) {
      console.warn("[Invoice Request] Could not persist pending B2B request", error);
      return false;
    }
  }

  function readPendingCompanyRequest() {
    try {
      const raw = window.sessionStorage.getItem(COMPANY_PENDING_KEY);
      if (!raw) return null;

      const parsed = JSON.parse(raw);

      // Don't resurrect stale fiscal data from old browsing sessions.
      if (!parsed?.createdAt || Date.now() - parsed.createdAt > 30 * 60 * 1000) {
        window.sessionStorage.removeItem(COMPANY_PENDING_KEY);
        return null;
      }

      return parsed;
    } catch (_error) {
      return null;
    }
  }

  function clearPendingCompanyRequest() {
    try {
      window.sessionStorage.removeItem(COMPANY_PENDING_KEY);
    } catch (_error) {}
  }

  function businessContextRefreshUrl() {
    const returnTo = encodeURIComponent("/cart");
    return `/customer_authentication/login?return_to=${returnTo}`;
  }

  async function finalizePendingCompanyRequest(widget) {
    const pending = readPendingCompanyRequest();
    if (!pending?.payload || !pending?.proxyData) return false;
    if (!isLoggedCustomer(widget)) return false;

    const { payload, proxyData } = pending;

    setChecked(widget, "company");
    setPanels(widget, "company");
    setBusy(widget, true);
    setMessage(widget, t.saving, "loading");

    try {
      await saveCartAttributes({
        invoice_requested: "true",
        invoice_type: "company",
        invoice_country_code: payload.countryCode || "",
        vat_number: proxyData.vatNumber || payload.vatNumber || "",
        company_name: payload.companyName || "",
        customer_email: proxyData.customerEmail || payload.customerEmail || "",
        pec: payload.pec || "",
        sdi: payload.sdi || "",
        invoice_request_status: proxyData.pendingManualReview || proxyData.reviewRequired ? "pending_review" : "registered",
        invoice_request_id: proxyData.invoiceRequestId || "",
        vies_checked: proxyData.viesChecked ? "true" : "false",
        vies_valid:
          proxyData.viesValid === true ? "true" : proxyData.viesValid === false ? "false" : "",
        reverse_charge: proxyData.reverseCharge ? "true" : "false",
        tax_exempt_applied: proxyData.taxExemptApplied ? "true" : "false",
        tax_exempt_customer_prepared: proxyData.taxExemptCustomerPrepared ? "true" : "false",
        vies_technical_error: proxyData.viesTechnicalError || proxyData.viesUnavailable ? "true" : "false",
        must_use_same_email_at_checkout: proxyData.mustUseSameEmailAtCheckout ? "true" : "false",
      });

      clearPendingCompanyRequest();
      setMessage(widget, getCompanySuccessMessage(proxyData), "success");
      return true;
    } catch (error) {
      console.error("[Invoice Request] Pending B2B cart finalization failed", {
        error: error?.message || String(error),
        companyId: proxyData?.companyId || "",
        companyLocationId: proxyData?.companyLocationId || "",
      });

      setMessage(widget, error.message || t.error, "error");
      return false;
    } finally {
      setBusy(widget, false);
    }
  }

  async function handleCompanySave(button) {
    const widget = widgetFrom(button);
    if (!widget) return;

    if (requiresCompanyLogin(widget) && !isLoggedCustomer(widget)) {
      setChecked(widget, "company");
      setMessage(widget, t.companyLoginRequired, "error");
      return;
    }

    updateItalianFiscalFields(widget);

    const country = getCompanyCountry(widget);
    const isItaly = country === "IT";
    const vatInput = widget.querySelector("[data-invoice-vat]");
    const vatRaw = vatInput?.value || "";
    const cleanVatInputValue = normalizeVatInputValue(country, vatRaw);
    const vat = buildVatForSelectedCountry(country, vatRaw);
    if (vatInput && cleanVatInputValue) vatInput.value = cleanVatInputValue;
    const companyName = widget.querySelector("[data-invoice-company-name]")?.value || "";
    const isLogged = isLoggedCustomer(widget);
    const email = isItaly
      ? ""
      : isLogged
        ? getLoggedCustomerEmail(widget)
        : widget.querySelector("[data-invoice-company-email]")?.value || "";
    const pec = isItaly ? widget.querySelector("[data-invoice-pec]")?.value || "" : "";
    const sdi = isItaly ? widget.querySelector("[data-invoice-sdi]")?.value || "" : "";

    if (!cleanVatInputValue) {
      setChecked(widget, "company");
      setPanels(widget, "company");
      setMessage(widget, t.vatRequired, "error");
      if (vatInput) vatInput.focus();
      return;
    }

    if (!isItaly && !isLogged && !isValidEmail(email)) {
      setChecked(widget, "company");
      setPanels(widget, "company");
      setMessage(widget, t.emailRequired, "error");
      return;
    }

    setBusy(widget, true);
    setPanels(widget, "company");
    setMessage(widget, t.saving, "loading");

    try {
      const companyPayload = {
        invoiceType: "company",
        countryCode: country,
        vatNumber: vat,
        companyName,
        customerEmail: email,
        pec,
        sdi,
      };

      const proxyData = await saveInvoiceRequest(companyPayload);

      if (proxyData?.requiresB2BContextRefresh) {
        if (!savePendingCompanyRequest(companyPayload, proxyData)) {
          throw new Error(t.error);
        }

        setMessage(widget, t.companyContextRefresh, "loading");

        window.setTimeout(() => {
          window.location.assign(businessContextRefreshUrl());
        }, 250);

        return;
      }

      await saveCartAttributes({
        invoice_requested: "true",
        invoice_type: "company",
        invoice_country_code: country,
        vat_number: proxyData.vatNumber || vat,
        company_name: companyName,
        customer_email: proxyData.customerEmail || email,
        pec,
        sdi,
        invoice_request_status: proxyData.pendingManualReview || proxyData.reviewRequired ? "pending_review" : "registered",
        invoice_request_id: proxyData.invoiceRequestId || "",
        vies_checked: proxyData.viesChecked ? "true" : "false",
        vies_valid:
          proxyData.viesValid === true ? "true" : proxyData.viesValid === false ? "false" : "",
        reverse_charge: proxyData.reverseCharge ? "true" : "false",
        tax_exempt_applied: proxyData.taxExemptApplied ? "true" : "false",
        tax_exempt_customer_prepared: proxyData.taxExemptCustomerPrepared ? "true" : "false",
        vies_technical_error: proxyData.viesTechnicalError || proxyData.viesUnavailable ? "true" : "false",
        must_use_same_email_at_checkout: proxyData.mustUseSameEmailAtCheckout ? "true" : "false",
      });

      setChecked(widget, "company");
      updateItalianFiscalFields(widget);
      setMessage(widget, getCompanySuccessMessage(proxyData), "success");
    } catch (error) {
      setChecked(widget, "company");
      setMessage(widget, error.message || t.error, "error");
    } finally {
      setBusy(widget, false);
    }
  }

  function applyCartStateToWidget(widget, cart) {
    if (!widget || !cart) return;

    const attributes = cart.attributes || {};
    const requested = normalizeBool(attributes.invoice_requested);
    const type = requested ? attributes.invoice_type || "none" : "none";

    setChecked(widget, type);

    if (requested && type === "private") {
      setMessage(widget, t.saved, "success");
    }

    if (requested && type === "company") {
      const countryInput = widget.querySelector("[data-invoice-country]");
      const vatInput = widget.querySelector("[data-invoice-vat]");
      const companyNameInput = widget.querySelector("[data-invoice-company-name]");
      const pecInput = widget.querySelector("[data-invoice-pec]");
      const sdiInput = widget.querySelector("[data-invoice-sdi]");
      const emailInput = widget.querySelector("[data-invoice-company-email]");

      if (countryInput && attributes.invoice_country_code) countryInput.value = attributes.invoice_country_code;
      if (vatInput && attributes.vat_number) vatInput.value = normalizeVatInputValue(getCompanyCountry(widget), attributes.vat_number);
      if (companyNameInput && attributes.company_name) companyNameInput.value = attributes.company_name;
      if (emailInput && attributes.customer_email) emailInput.value = attributes.customer_email;
      if (pecInput && attributes.pec) pecInput.value = attributes.pec;
      if (sdiInput && attributes.sdi) sdiInput.value = attributes.sdi;

      updateItalianFiscalFields(widget);

      if (normalizeBool(attributes.vies_technical_error)) {
        setMessage(widget, t.viesBusySaved, "success");
      } else if (attributes.invoice_request_status === "pending_review") {
        setMessage(widget, t.manualReviewSaved, "success");
      } else if (normalizeBool(attributes.tax_exempt_applied) || normalizeBool(attributes.tax_exempt_customer_prepared)) {
        setMessage(widget, t.vatExemptApplied, "success");
      } else if (normalizeBool(attributes.reverse_charge)) {
        setMessage(widget, t.reverseChargeGranted, "success");
      } else {
        setMessage(widget, t.companySaved, "success");
      }
    }
  }

  function resumeCompanyAfterLogin(widget) {
    if (!widget || !isLoggedCustomer(widget)) return false;

    try {
      const shouldResume = window.sessionStorage.getItem("invoice_company_login_resume") === "true";
      if (!shouldResume) return false;

      window.sessionStorage.removeItem("invoice_company_login_resume");
      setChecked(widget, "company");
      setMessage(widget, "", null);
      return true;
    } catch (_error) {
      return false;
    }
  }

  async function syncExistingWidgets() {
    if (syncing) return;
    syncing = true;

    try {
      const widgets = Array.from(document.querySelectorAll("[data-invoice-request-widget]"));
      if (!widgets.length) return;

      const cart = await getCart();
      for (const widget of widgets) {
        applyCartStateToWidget(widget, cart);

        const finalizedPending = await finalizePendingCompanyRequest(widget);
        if (!finalizedPending) {
          resumeCompanyAfterLogin(widget);
        }
      }
    } catch (_error) {
      document.querySelectorAll("[data-invoice-request-widget]").forEach((widget) => {
        const checked = widget.querySelector('input[name="invoice_type"]:checked');
        setPanels(widget, checked ? checked.value : "none");
      });
    } finally {
      syncing = false;
    }
  }

  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncExistingWidgets, 100);
  }

  document.addEventListener("change", function (event) {
    const input = event.target;

    if (input && input.matches && input.matches('[data-invoice-request-widget] [data-invoice-country]')) {
      const widget = widgetFrom(input);
      const vatInput = widget?.querySelector("[data-invoice-vat]");
      if (vatInput) vatInput.value = normalizeVatInputValue(input.value, vatInput.value);
      updateVatPrefix(widget);
      updateItalianFiscalFields(widget);
      setMessage(widget, "", null);
      return;
    }

    if (input && input.matches && input.matches('[data-invoice-request-widget] input[name="invoice_type"]')) {
      handleTypeChange(input);
    }
  });

  document.addEventListener("blur", function (event) {
    const input = event.target;

    if (input && input.matches && input.matches('[data-invoice-request-widget] [data-invoice-vat]')) {
      const widget = widgetFrom(input);
      input.value = normalizeVatInputValue(getCompanyCountry(widget), input.value);
    }
  }, true);

  document.addEventListener("click", function (event) {
    const loginLink = event.target && event.target.closest ? event.target.closest("[data-invoice-company-login]") : null;

    if (loginLink) {
      try {
        window.sessionStorage.setItem("invoice_company_login_resume", "true");
      } catch (_error) {
        // Continue to Shopify login even when sessionStorage is unavailable.
      }
      return;
    }

    const button = event.target && event.target.closest ? event.target.closest("[data-invoice-validate]") : null;
    if (!button) return;

    event.preventDefault();
    handleCompanySave(button);
  });

  document.addEventListener("DOMContentLoaded", scheduleSync);
  document.addEventListener("shopify:section:load", scheduleSync);
  document.addEventListener("cart:refresh", scheduleSync);
  document.addEventListener("cart:updated", scheduleSync);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (!mutation.addedNodes || !mutation.addedNodes.length) continue;

      for (const node of mutation.addedNodes) {
        if (!node || node.nodeType !== 1) continue;

        if (
          node.matches?.("[data-invoice-request-widget]") ||
          node.querySelector?.("[data-invoice-request-widget]")
        ) {
          scheduleSync();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  scheduleSync();
})();
